<script lang="ts">
  import Close from "../assets/icons/close.svg";

  export let onOverlayClick: () => void;
  export let onCloseClick: () => void;

  const onSliderClick = (event: Event) => {
    event.stopPropagation();
  };
</script>

<button class="overlay fixed top-0 left-0 w-full h-full z-50" data-testid="overlay" on:click={onOverlayClick}>
  <button class="slider bg-white w-full h-5/6 lg:h-full absolute" on:click={onSliderClick}>
    <button class="w-6 h-6 shrink-0 absolute top-4 right-4 lg:top-5 lg:right-6 flex items-center justify-center" on:click={onCloseClick}>
      <img src={Close} alt="Close" />
    </button>
    <slot></slot>
  </button>
</button>

<style>
  /* TODO: add tansitions */
  .overlay {
    background-color: rgba(0, 0, 0, 0.5);
  }

  .slider {
    bottom: 0;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    right: 0;
  }

  @media (min-width: 1024px) {
    .slider {
      top: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      width: 25rem;
    }
  }
</style>
